export const UIControlStatuses = {
    initial: "initial",
    submitSuccess: "submitSuccess",
    submitFailure: "submitFailure",
    submitLoading: "submitLoading",
    unsubmitted: "unsubmitted",
    submitError: "submitError"
};
